import React from 'react';

interface FullscreenLoaderProps {
  isVisible: boolean;
  message?: string;
  showBackground?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const FullscreenLoader: React.FC<FullscreenLoaderProps> = ({ 
  isVisible, 
  message,
  showBackground = true,
  size = 'large',
  className = ""
}) => {
  if (!isVisible) return null;

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'h-8 w-8 border-2';
      case 'medium':
        return 'h-12 w-12 border-3';
      default:
        return 'h-16 w-16 border-4';
    }
  };

  const containerClasses = showBackground 
    ? "fixed inset-0 z-50 flex items-center justify-center"
    : `flex items-center justify-center ${className}`;

  return (
    <div className={containerClasses}>
      {showBackground && (
        <div 
          className="absolute inset-0 bg-black"
          style={{ opacity: 0.6 }}
        />
      )}
      
      <div className={`${showBackground ? 'relative z-10' : ''} flex flex-col items-center space-y-4`}>
        <div className={`animate-spin rounded-full border-transparent ${getSizeClasses()}`}
             style={{ borderTopColor: 'var(--snaiColor)' }}>
        </div>
        
        {message && (
          <p className="text-white text-lg font-medium text-center px-4">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default FullscreenLoader;